import { format } from 'date-fns/format';
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';
import { enUS } from 'date-fns/locale/en-US';
import { ja } from 'date-fns/locale/ja';
import { pt } from 'date-fns/locale/pt';
import { zhCN } from 'date-fns/locale/zh-CN';
import { es } from 'date-fns/locale/es';
import { ptBR } from 'date-fns/locale/pt-BR';

import { SupportedLocale } from '../i18n/SupportedLocale';


const localeMap = {
  [SupportedLocale.EN_US]: enUS,
  [SupportedLocale.ZH_CN]: zhCN,
  [SupportedLocale.JA_JP]: ja,
  [SupportedLocale.PT_PT]: pt,
  [SupportedLocale.ES_ES]: es,
  [SupportedLocale.PT_BR]: ptBR,
};

export function fromNow(date: Date | string, supportedLocale: SupportedLocale) {
  try {
    const locale = localeMap[supportedLocale] ?? enUS;

    return formatDistanceToNow(date, {
      addSuffix: true,
      locale,
    });
  } catch (_error) {
    if (_error) {
      //
    }

    return 'Invalid time';
  }
}

export function formatDate(date: string | Date, supportedLocale: SupportedLocale) {
  const locale = localeMap[supportedLocale] ?? enUS;
  return format(date, 'yyyy-MM-dd HH:mm:ss', {
    locale,
  });
}
